<script setup>
import { useSnackbarStore } from '@core/stores/SnackbarStore'

const snackbarStore = useSnackbarStore()
</script>

<template>
  <VSnackbar
    v-model="snackbarStore.show"
    :timeout="snackbarStore.timeout"
    :color="snackbarStore.color"
    :location="snackbarStore.location"
    elevation="24"
    rounded="lg"
    vertical
  >
    <div class="d-flex align-center">
      <!-- Icon based on message type -->
      <VIcon
        :icon="snackbarStore.icon"
        size="large"
        class="me-3"
      />

      <!-- Message text with better contrast -->
      <div class="snackbar-message">
        {{ snackbarStore.message }}
      </div>
    </div>

    <template #actions>
      <VBtn
        variant="tonal"
        class="snackbar-action-btn"
        size="small"
        @click="snackbarStore.hide"
      >
        {{ snackbarStore.actionText || 'Close' }}
      </VBtn>
    </template>
  </VSnackbar>
</template>

<style scoped>
.snackbar-message {
  font-size: 0.875rem;
  font-weight: 400;
  color: white;
  line-height: 1.5;
}

/* Ensure good contrast for all snackbar colors */
:deep(.v-snackbar__content) {
  padding: 16px !important;
}

:deep(.v-snackbar--variant-elevated) {
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2),
  0 6px 10px 0 rgba(0, 0, 0, 0.14),
  0 1px 18px 0 rgba(0, 0, 0, 0.12) !important;
}

/* Style the action button for better visibility */
.snackbar-action-btn {
  background-color: rgba(255, 255, 255, 0.9) !important;
  color: rgba(0, 0, 0, 0.87) !important;
}

.snackbar-action-btn:hover {
  background-color: rgba(255, 255, 255, 1) !important;
}

/* Dark theme adjustments */
.v-theme--dark .snackbar-action-btn {
  background-color: rgba(255, 255, 255, 0.15) !important;
  color: white !important;
}

.v-theme--dark .snackbar-action-btn:hover {
  background-color: rgba(255, 255, 255, 0.25) !important;
}
</style>
